/* Maison Dolce — interactions du thème */
(function () {
  "use strict";

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  function money(cents) {
    return (cents / 100).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function showToast(msg) {
    var t = $("#toast");
    if (!t) return;
    t.textContent = msg;
    t.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove("show"); }, 2600);
  }

  /* ---------- halo qui suit le curseur ---------- */
  (function () {
    if (!window.matchMedia || !matchMedia("(hover:hover)").matches) return;
    var SEL = ".btn, .swatch, .filter-chip, .tab-head, .quick-add, .info-acc-head, .card-glow, .prod-card, .col-card, .value-card, .panel, .usage-card";
    var pending = null, ticking = false;
    function flush() {
      ticking = false;
      if (!pending) return;
      var el = pending.el, x = pending.x, y = pending.y;
      pending = null;
      var r = el.getBoundingClientRect();
      el.style.setProperty("--mx", (x - r.left).toFixed(1) + "px");
      el.style.setProperty("--my", (y - r.top).toFixed(1) + "px");
    }
    document.addEventListener("pointermove", function (e) {
      if (e.pointerType === "touch") return;
      var el = e.target && e.target.closest ? e.target.closest(SEL) : null;
      if (!el) return;
      pending = { el: el, x: e.clientX, y: e.clientY };
      if (!ticking) { ticking = true; requestAnimationFrame(flush); }
    }, { passive: true });
  })();

  /* ---------- menu mobile ---------- */
  (function () {
    var btn = $("#mobileMenuBtn"), nav = $("#mobileNav"), back = $("#mobileNavBackdrop"), close = $("#mobileNavClose");
    if (!btn || !nav) return;
    function set(open) {
      btn.classList.toggle("open", open);
      btn.setAttribute("aria-expanded", open ? "true" : "false");
      nav.classList.toggle("open", open);
      nav.setAttribute("aria-hidden", open ? "false" : "true");
      if (back) back.classList.toggle("open", open);
      document.body.classList.toggle("menu-open", open);
    }
    btn.addEventListener("click", function () { set(!nav.classList.contains("open")); });
    if (back) back.addEventListener("click", function () { set(false); });
    if (close) close.addEventListener("click", function () { set(false); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") set(false); });
  })();

  /* ---------- recherche prédictive ---------- */
  (function () {
    var overlay = $("#searchOverlay"), input = $("#searchInput"), results = $("#searchResults");
    var openBtn = $("#searchBtn"), closeBtn = $("#searchClose");
    if (!overlay || !input) return;
    var ctrl = null, timer = null;
    var IDLE = '<div class="search-empty">Tapez pour rechercher dans la boutique.</div>';

    function open() {
      overlay.hidden = false;
      document.body.classList.add("menu-open");
      input.value = "";
      results.innerHTML = IDLE;
      setTimeout(function () { input.focus(); }, 40);
    }
    function close() {
      overlay.hidden = true;
      document.body.classList.remove("menu-open");
    }
    if (openBtn) openBtn.addEventListener("click", open);
    if (closeBtn) closeBtn.addEventListener("click", close);
    overlay.addEventListener("click", function (e) { if (e.target === overlay) close(); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !overlay.hidden) close(); });

    input.addEventListener("input", function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (!q) { results.innerHTML = IDLE; return; }
      timer = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        var url = routes + "search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=8";
        fetch(url, { signal: ctrl.signal })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var items = (d.resources && d.resources.results && d.resources.results.products) || [];
            if (!items.length) {
              results.innerHTML = '<div class="search-empty">Aucun produit ne correspond à «&nbsp;' + q + '&nbsp;».</div>';
              return;
            }
            results.innerHTML = items.map(function (p) {
              var img = p.featured_image && p.featured_image.url
                ? '<img src="' + p.featured_image.url + '" alt="" loading="lazy" width="88" height="88">'
                : "";
              return '<a class="search-row" href="' + p.url + '">' +
                '<div class="art-frame' + (img ? "" : " ph") + '">' + img + "</div>" +
                '<div><div class="sr-name">' + p.title + '</div><div class="sr-price">' + p.price + "</div></div></a>";
            }).join("");
          })
          .catch(function (e) {
            if (e.name !== "AbortError") results.innerHTML = '<div class="search-empty">Recherche momentanément indisponible.</div>';
          });
      }, 220);
    });
  })();

  /* ---------- galerie produit ---------- */
  (function () {
    var gallery = $("#ppGallery");
    if (!gallery) return;
    var frame = $("#ppGalleryFrame", gallery);
    var slides = $$(".pp-slide", gallery);
    var thumbs = $$(".pp-thumb", gallery);
    var idxEl = $("#ppIndex");
    var i = 0, n = slides.length;

    gallery.classList.toggle("single", n <= 1);
    if (frame) frame.classList.toggle("no-drag", n <= 1);
    $$(".pp-arrow", gallery).forEach(function (a) { a.style.display = n <= 1 ? "none" : ""; });
    var counter = $(".pp-counter", gallery);
    if (counter) counter.style.display = n <= 1 ? "none" : "";

    function go(k) {
      if (!n) return;
      i = ((k % n) + n) % n;
      slides.forEach(function (s, x) { s.hidden = x !== i; });
      thumbs.forEach(function (t, x) { t.classList.toggle("active", x === i); });
      if (idxEl) idxEl.textContent = i + 1;
    }
    go(0);
    window.dolceGallery = { go: go, index: function () { return i; } };

    /* flèches : on stoppe la propagation pour ne pas déclencher le glissement */
    var prev = $("#ppPrev"), next = $("#ppNext");
    function arrow(btn, delta) {
      if (!btn) return;
      btn.addEventListener("pointerdown", function (e) { e.stopPropagation(); });
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        go(i + delta);
      });
    }
    arrow(prev, -1);
    arrow(next, 1);

    thumbs.forEach(function (t, x) {
      t.addEventListener("click", function (e) { e.preventDefault(); go(x); });
    });

    document.addEventListener("keydown", function (e) {
      if (e.target && e.target.matches && e.target.matches("input, textarea")) return;
      if (e.key === "ArrowLeft") go(i - 1);
      if (e.key === "ArrowRight") go(i + 1);
    });

    /* glissement souris / tactile — sans capture de pointeur (elle volait le clic des flèches) */
    if (frame && n > 1) {
      var sx = null, sy = null;
      frame.addEventListener("pointerdown", function (e) {
        if (e.target.closest && e.target.closest(".pp-arrow")) return;
        sx = e.clientX; sy = e.clientY;
      });
      frame.addEventListener("pointerup", function (e) {
        if (sx === null) return;
        var dx = e.clientX - sx, dy = e.clientY - sy;
        sx = null; sy = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) go(i + (dx < 0 ? 1 : -1));
      });
      frame.addEventListener("pointercancel", function () { sx = null; sy = null; });
      frame.addEventListener("dragstart", function (e) { e.preventDefault(); });
    }
  })();

  /* ---------- sélection de variante ---------- */
  (function () {
    var dataEl = $("#variantData");
    if (!dataEl) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = $("#variantId"), priceEl = $("#pricePrimary"), mainPriceEl = $("#mainPrice");
    var stockEl = $("#ppStock"), addBtn = $("#addCartBtn"), labelEl = $("#sizeLabel");

    function select(v) {
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (mainPriceEl) mainPriceEl.textContent = money(v.price);
      if (labelEl) labelEl.textContent = v.title;
      if (stockEl) stockEl.hidden = !v.available;
      if (addBtn) addBtn.disabled = !v.available;
      $$(".size-table tr[data-size-row]").forEach(function (r) {
        r.classList.toggle("match", r.getAttribute("data-size-row") === v.title);
      });
      if (v.featured_index !== null && v.featured_index !== undefined && window.dolceGallery) {
        window.dolceGallery.go(v.featured_index);
      }
      try {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", v.id);
        window.history.replaceState({}, "", url);
      } catch (e) {}
    }

    $$(".swatch[data-variant-id]").forEach(function (sw) {
      sw.addEventListener("click", function () {
        if (sw.disabled) return;
        $$(".swatch[data-variant-id]").forEach(function (s) { s.classList.toggle("active", s === sw); });
        var id = sw.getAttribute("data-variant-id");
        for (var k = 0; k < variants.length; k++) {
          if (String(variants[k].id) === id) { select(variants[k]); break; }
        }
      });
    });
  })();

  /* ---------- onglets ---------- */
  $$(".tab-head").forEach(function (btn) {
    btn.addEventListener("click", function () {
      $$(".tab-head").forEach(function (b) { b.classList.toggle("active", b === btn); });
      $$(".tab-panel").forEach(function (p) { p.hidden = p.getAttribute("data-panel") !== btn.getAttribute("data-tab"); });
    });
  });

  /* ---------- accordéons ---------- */
  document.addEventListener("click", function (e) {
    var head = e.target.closest ? e.target.closest(".info-acc-head") : null;
    if (head) {
      var item = head.closest(".info-acc-item");
      var body = item.querySelector(".info-acc-body");
      var open = item.classList.toggle("open");
      body.style.maxHeight = open ? body.scrollHeight + "px" : null;
      return;
    }
    var q = e.target.closest ? e.target.closest(".faq-q") : null;
    if (q) {
      var fitem = q.closest(".faq-item");
      var a = fitem.querySelector(".faq-a");
      var fopen = fitem.classList.toggle("open");
      a.style.maxHeight = fopen ? a.scrollHeight + "px" : null;
    }
  });
  var rTimer;
  window.addEventListener("resize", function () {
    clearTimeout(rTimer);
    rTimer = setTimeout(function () {
      $$(".info-acc-item.open .info-acc-body, .faq-item.open .faq-a").forEach(function (b) {
        b.style.maxHeight = b.scrollHeight + "px";
      });
    }, 150);
  });

  /* ---------- filtres de collections ---------- */
  (function () {
    var row = $("#collFilters");
    if (!row) return;
    row.addEventListener("click", function (e) {
      var chip = e.target.closest ? e.target.closest("[data-filter]") : null;
      if (!chip) return;
      $$(".filter-chip", row).forEach(function (c) { c.classList.toggle("active", c === chip); });
      var f = chip.getAttribute("data-filter");
      $$("#colGrid .col-card").forEach(function (card) {
        card.classList.toggle("hide", f !== "*" && card.getAttribute("data-cat") !== f);
      });
    });
  })();

  /* ---------- avis en rotation ---------- */
  (function () {
    var dots = $("#quoteDots"), textEl = $("#quoteText"), whoEl = $("#quoteWho"), dataEl = $("#quoteData");
    if (!dots || !textEl || !dataEl) return;
    var quotes = [];
    try { quotes = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!quotes.length) return;
    var i = 0, timer = null;
    dots.innerHTML = quotes.map(function (_, k) {
      return '<button class="quote-dot" type="button" data-quote="' + k + '" aria-label="Avis ' + (k + 1) + '"></button>';
    }).join("");
    function show(k) {
      i = ((k % quotes.length) + quotes.length) % quotes.length;
      textEl.textContent = quotes[i][0];
      if (whoEl) whoEl.textContent = quotes[i][1];
      $$(".quote-dot", dots).forEach(function (d, x) { d.classList.toggle("active", x === i); });
    }
    function loop() { clearInterval(timer); timer = setInterval(function () { show(i + 1); }, 5200); }
    show(0); loop();
    dots.addEventListener("click", function (e) {
      var d = e.target.closest ? e.target.closest("[data-quote]") : null;
      if (!d) return;
      show(parseInt(d.getAttribute("data-quote"), 10));
      loop();
    });
  })();

  /* ---------- barre d'achat collante ---------- */
  (function () {
    var target = $(".pp-cta"), bar = $("#stickyBuy");
    if (!target || !bar) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle("show", entries[0].isIntersecting === false && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(target);
    var btn = $("#stickyAdd");
    if (btn) btn.addEventListener("click", function () { var a = $("#addCartBtn"); if (a) a.click(); });
  })();

  /* ---------- panier (API AJAX) ---------- */
  function refreshCartCount() {
    return fetch(routes + "cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var badge = $(".cart-count");
        if (badge) { badge.textContent = cart.item_count; badge.hidden = cart.item_count === 0; }
        return cart;
      });
  }
  function refreshMiniCart() {
    return fetch(routes + "?section_id=dolce-mini-cart")
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = doc.querySelector("#miniCartInner");
        var cur = $("#miniCartInner");
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }
  function refreshCartSection() {
    var wrap = $("#cartSection");
    if (!wrap) return Promise.resolve();
    return fetch(routes + "cart?section_id=dolce-cart")
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = doc.querySelector("#cartSection");
        if (fresh) wrap.innerHTML = fresh.innerHTML;
      });
  }

  document.addEventListener("click", function (e) {
    var qa = e.target.closest ? e.target.closest("[data-quick-add]") : null;
    if (!qa) return;
    e.preventDefault();
    e.stopPropagation();
    var id = qa.getAttribute("data-quick-add");
    if (!id) return;
    qa.classList.add("is-busy");
    fetch(routes + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d.status) throw new Error(d.description || d.message);
        showToast((qa.getAttribute("data-title") || "Article") + " — ajouté au panier");
        return Promise.all([refreshCartCount(), refreshMiniCart()]);
      })
      .catch(function (err) { showToast(err.message || "Ajout impossible"); })
      .then(function () { qa.classList.remove("is-busy"); });
  });

  (function () {
    var form = $("#productForm");
    if (!form) return;
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = $("#addCartBtn");
      if (btn) btn.classList.add("is-busy");
      fetch(routes + "cart/add.js", { method: "POST", body: new FormData(form) })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d.status) throw new Error(d.description || d.message);
          showToast(d.product_title + " — ajouté au panier");
          return Promise.all([refreshCartCount(), refreshMiniCart()]);
        })
        .catch(function (err) { showToast(err.message || "Ajout impossible"); })
        .then(function () { if (btn) btn.classList.remove("is-busy"); });
    });
  })();

  document.addEventListener("click", function (e) {
    var q = e.target.closest ? e.target.closest("[data-cart-qty]") : null;
    var r = e.target.closest ? e.target.closest("[data-cart-remove]") : null;
    if (!q && !r) return;
    e.preventDefault();
    var el = q || r;
    var line = Number(el.getAttribute("data-line"));
    var qty = r ? 0 : Math.max(0, Number(q.getAttribute("data-qty") || 0) + Number(q.getAttribute("data-delta")));
    var box = $("#cartSection");
    if (box) box.classList.add("is-busy");
    fetch(routes + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (res) { return res.json(); })
      .then(function () { return Promise.all([refreshCartSection(), refreshCartCount(), refreshMiniCart()]); })
      .then(function () { if (r) showToast("Article retiré"); })
      .catch(function () { showToast("Mise à jour impossible"); })
      .then(function () { if (box) box.classList.remove("is-busy"); });
  });
})();
